import { render } from "./CenteredDialog.vue?vue&type=template&id=4675a5a8"
const script = {}

import exportComponent from "/Users/leopons/Desktop/Projects/cryptos/bubble-graph/bubblemaps-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__